// client/src/components/pages/LexiStar/Approvals/driverReply.ts
//
// The driver's reply on an approvals-queue row, whichever shape it arrives in:
// the engine stores `lexistar.deviations.driver_reason` as
// `{reason_code, text, media, message_id, via, at, actor}` (m3-contracts §5.1;
// GET /deviations passes it through), while the page was first written against
// the UI's reading `{code, text, photo_url, replied_at}` (services/
// lexistarStatusBoard.js DeviationRow). Both are read; the photos come from
// `driver_reason_media` (services/lexistarMedia.ts driverPhotosOf).

export interface DriverReply {
  /** The reason code (deviation reason codes, e.g. road_closed). */
  code: string | null;
  text: string | null;
  /** When the driver answered (ISO). */
  repliedAt: string | null;
  /** A direct photo link (the UI's early reading; no server sends it today). */
  photoUrl: string | null;
}

const str = (v: unknown): string | null => (typeof v === 'string' && v.length > 0 ? v : null);

/** null when the deviation has no driver reply. */
export function driverReplyOf(reason: unknown): DriverReply | null {
  if (!reason || typeof reason !== 'object') return null;
  const r = reason as Record<string, unknown>;
  return {
    code: str(r.code) ?? str(r.reason_code),
    text: str(r.text),
    repliedAt: str(r.replied_at) ?? str(r.at),
    photoUrl: str(r.photo_url),
  };
}
